<template>
  <p-img
    v-if="showImg"
    :imgPath="showImg"
    :openModal="false"
    @return="showImg = null"
    :allImages="allImages"
  />
  <div v-else-if="isEdit">
    <local-add-service-call
      :PID="serviceCallSelectedDataLocal.PID"
      @serviceCallChanged="serviceCallChanged"
      :close="
        () => {
          isEdit = false;
        }
      "
    ></local-add-service-call>
  </div>
  <div v-else-if="serviceCallSelectedDataLocal">
    <div class="data">
      <div class="field">
        <label class="label">{{ __("Opening date") }}:</label>
        <span>{{
          serviceCallSelectedDataLocal.OpD
            ? dateFormat(
                new Date(serviceCallSelectedDataLocal.OpD),
                false,
                false,
                true
              )
            : ""
        }}</span>
      </div>
      <div class="field">
        <label class="label">{{ __("Due Date") }}:</label>
        <span>{{
          serviceCallSelectedDataLocal.DDueDate
            ? dateFormat(
                new Date(serviceCallSelectedDataLocal.DDueDate),
                false,
                false,
                true
              )
            : ""
        }}</span>
      </div>
    </div>
    <div class="field" v-if="serviceCallSelectedDataLocal.Updates.length > 1">
      <label class="label">{{ __("Updates") }}:</label>
      <p-vue-carousel
        :value="serviceCallSelectedDataLocal.Updates"
        class="custom-carousel"
        :circular="true"
        :autoplayInterval="5000"
      >
        <template #item="slotProps">
          <local-updates :data="slotProps.data" />
        </template>
      </p-vue-carousel>
    </div>
    <div v-else-if="serviceCallSelectedDataLocal.Updates.length == 1">
      <label class="label">{{ __("Last update") }}:</label>
      <div class="last_update">
        <local-updates :data="serviceCallSelectedDataLocal.Updates[0]" />
      </div>
    </div>
    <div class="field" v-else>
      <label class="label">{{
        __("There are no updates for this call")
      }}</label>
    </div>
    <div
      class="attachments"
      v-if="serviceCallSelectedDataLocal.Images.length > 0"
    >
      <h6 class="label">{{ __("Photos") }}:</h6>
      <ul>
        <li
          v-for="(image, index) in serviceCallSelectedDataLocal.Images"
          :key="index"
        >
          <a
            href="#"
            @click.prevent="showBigImg(image.PathImg)"
            >{{ __("Picture") }} {{ image.Subject }}
          </a>
        </li>
      </ul>
    </div>
    <div class="field" v-else>
      <label class="label">
        {{ __("No photos were attached for this reading") }}</label
      >
    </div>
  </div>
  <div class="p-d-flex p-jc-end p-mt-2" v-if="!isEdit">
    <p-vue-button
      v-if="!showImg"
      class="button p-button-rounded p-button-success"
      :label="__('Edit')"
      @click="editServiceCall"
    />
    <p-vue-button
      class="button p-button-rounded p-button-success p-mr-2"
      :label="__(showImg ? 'Return' : 'Close')"
      @click="CloseBtn"
    />
  </div>
</template>

<script>
import { __ } from "@/plugins/i18n/";
import { API_HOST } from "@/services/APointAPI";
import { mapState } from "vuex";
import PImg from "@/components/partials/p-img";
import LocalUpdates from "./p-service-calls-update";
import LocalAddServiceCall from "@/views/v-service-calls/add-service-call";
import { dateFormat } from "@/services/apointUtil";

export default {
  components: {
    LocalUpdates,
    PImg,
    LocalAddServiceCall,
  },
  props: { serviceCallSelectedData: Object, close: Function },
  emits: ["serviceCallChanged", "reloadData"],
  data() {
    return {
      translate: __,
      API_HOST,
      showImg: null,
      isEdit: false,
      allImages: [],
      serviceCallSelectedDataLocal: null,
      dateFormat,
    };
  },
  mounted() {
    this.serviceCallSelectedDataLocal = this.serviceCallSelectedData;
  },
  methods: {
    showBigImg(imgID) {
      this.showImg = imgID;
      this.allImages = this.serviceCallSelectedDataLocal.Images.map((img) => {
        return { imgPath: img.PathImg, imgSubject: img.Subject };
      });
    },
    CloseBtn() {
      if (this.showImg) this.showImg = null;
      else if (this.isEdit) this.isEdit = false;
      else this.close();
    },
    editServiceCall() {
      this.isEdit = true;
      this.showImg = null;
    },
    serviceCallChanged(serviceCall) {
      // console.log(serviceCall, this.serviceCallSelectedData);
      this.serviceCallSelectedDataLocal.BID = serviceCall.BID;
      this.serviceCallSelectedDataLocal.BuildingName = serviceCall.BuildingName;
      this.serviceCallSelectedDataLocal.DDueDate = serviceCall.DueDate;
      this.serviceCallSelectedDataLocal.LastUpdateDate =
        serviceCall.LastDateUpdate;
      this.serviceCallSelectedDataLocal.OpD = serviceCall.OpenDate;
      this.serviceCallSelectedDataLocal.Subject = serviceCall.Subject;
      this.serviceCallSelectedDataLocal.Tupal = serviceCall.statusDesc;
      this.serviceCallSelectedDataLocal.ClosingDate = serviceCall.ClosingDate;
      this.$emit("reloadData");
      this.CloseBtn();
    },
  },
  computed: {
    ...mapState({
      sessionToken: (state) => state.api.sessionToken,
    }),
  },
};
</script>

<style scoped>
.data {
  display: grid;
  gap: 15px 25px;
  /* justify-content: space-between; */
  grid-template-columns: auto auto;
}

.field {
  display: flex;
  flex-direction: column;

  margin-bottom: 15px;

  font-size: 14px;
}

.label {
  margin-bottom: 5px;

  font-size: 14px;
  font-weight: normal;
  letter-spacing: 0.45px;
  color: var(--color-primary);
}

.preview {
  display: block;

  width: max-content;

  margin-left: auto;
  margin-right: auto;

  color: var(--color-success);
}

.preview:deep(.svg) {
  width: 25px;
  height: 25px;
}

h6.label {
  margin-top: 15px;
}

.attachments ul {
  display: flex;
  flex-wrap: wrap;

  margin: 0;
  padding: 0;

  list-style: none;
}

.attachments ul li a {
  letter-spacing: 0.45px;
  color: var(--color-success-active);
}

.attachments ul li:not(:last-child) a:after {
  content: ",";
}

:deep(.p-carousel-item) {
  direction: rtl;
}

:deep(.p-carousel-content) {
  direction: ltr;
}

:deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
  width: 0.5rem;
}

.last_update {
  padding: 20px;
}
</style>
